import React from 'react';

const VideoDisplay = ({ videoUrl }) => {
  if (!videoUrl) {
    return null; // Don't render anything if there's no video URL
  }

  return (
    // Added specific class 'video-display-wrapper' and kept w-full
    <div className="mt-6 w-full video-display-wrapper"> 
      <h2 className="text-2xl text-white mb-4">Generated Video</h2>
      {/* video-container will take full width of its parent (the div above) */}
      <div className="video-container mx-auto w-full"> {/* Kept w-full here for now, CSS will also target .video-container */}
        {/* 
          - video tag will now be primarily styled by App.css via ".video-container video"
          - Removed inline style for maxHeight and display:block, will move to CSS.
          - Kept Tailwind classes for rounding and initial bg, can be overridden by App.css if needed.
        */}
        <video 
          key={videoUrl} 
          controls 
          className="w-full max-w-full rounded-lg bg-black" 
          // style={{ maxHeight: '70vh', display: 'block' }} // Style moved to App.css
        >
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default VideoDisplay;
